<template>
  <div>  
    <ReprisePlannerLayout
      v-if="hasData"
    >
      <template
        #left-section
      >
        <v-card
          elevation="0"
          class="flex-grow-1 d-flex flex-column justify-space-between"
        >
          <v-card-title
            class="
              pt-2
              body-1 font-weight-bold
            "
          >
            Reprises du jour
          </v-card-title>
          <v-card-actions
            class="
              gap-2
              d-flex flex-column align-start
              pb-0 pl-4
              font-weight-bold
            "
          >
            <span class="caption font-weight-bold">Catégories de taille</span>
  
            <v-skeleton-loader
              :loading="isLoading"
              type="date-picker-days"
              :types="{
                'date-picker-days': 'avatar@4'
              }"
            >
              <fieldset
                class="
                  d-flex gap-4
                  border-0
                "
                style="border: 0;"
              >
                <div
                  v-for="(category, categoryIndex) in horseCategories"
                  :key="categoryIndex"
                  class="d-flex flex-column justify-center align-center"
                >
                  <label :for="`${categoryIndex}-checkbox`" class="font-weight-bold caption pointer">{{ category.label }}</label>
                  <v-checkbox
                    :id="`${categoryIndex}-checkbox`"
                    hide-details
                    class="ma-0"
                    color="third"
                    :ripple="false"
                    :input-value="horseCategories[categoryIndex].checkbox"
                    @change="updateFilter(horseCategories[categoryIndex].label, $event)"
                  />
                </div>
              </fieldset>
            </v-skeleton-loader>
          </v-card-actions>
        </v-card>
      </template>

      <template 
        v-if="sessions.length"
        #right-section
      >
        <SessionCard
          v-for="(session, sessionIndex) in sessions"
          :key="sessionIndex"
          :session-object="session"
          :is-instructors-loading="isLoading"
          @edit-session="editSession(session)"
        />
      </template>
    </ReprisePlannerLayout>
    <div v-else 
      class="d-flex flex-column align-center justify-center gap-4 light-grey-bg"
      style="height: calc(100vh - (72px + 56px));"
    >
      <h2 class="text-h5 font-weight-bold">Aucune donnée disponible</h2>
      <p 
        class="
          mb-0 
          text-h6 grey--text text--darken9
        "
      >Aucune session/reprise ou cheval n’est disponible pour la date ou les filtres sélectionnés.</p>
    </div>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount } from '@vue/composition-api';
import { EventBus, getReferences } from '@/helpers/utils';
import store from '@/store';

import ReprisePlannerLayout from '@/components/reprises/planner/ReprisePlannerLayout.vue';
import SessionCard from '@/components/reprises/components/SessionCard.vue';

export default {
  name: 'ReprisesPlanner',
  components: {
    ReprisePlannerLayout,
    SessionCard
  },
  setup () {
    const isLoading = ref(false);

    const sessions = computed(() => store.getters['sessionsFilters/repriseTab'](store.getters.sortedDailySessions));
    const horses = computed(() => store.getters['horsesFilters/repriseTab'](store.state.horses));    
    const hasData = computed(() => (sessions.value.length && (!store.state.isLazyLoaded.horses || horses.value.length)));

    const editSession = session => {
      EventBus.$emit('showEditSession', {session});
      EventBus.$emit('closeDrawerState');
    };
    const horseCategories = ref([]);

    const updateFilter = (label, value) => {
      store.commit('horsesFilters/setFilters', { key: 'sizeCategory', value: value ? label : null });
      horseCategories.value = horseCategories.value.map(category => ({ ...category, checkbox: value && category.label === label }));
    };

    onBeforeMount(async () => {
      if (!sessions.value) return;

      isLoading.value = true;
      if (!store.state.isLazyLoaded.instructors) {
        await store.dispatch('getInstructors');
      }

      horseCategories.value = (getReferences('horseSizeCategory') || []).map(category => ({ label: category.label, checkbox: false }));

      isLoading.value = false;
    });

    return { sessions, editSession, isLoading, horseCategories, updateFilter, horses, hasData }
  }
};
</script>

<style>
[data-component-id="reprise-planner-layout"] {
  .v-skeleton-loader__date-picker-days {
    padding: 0;
  }
}
</style>